import React from 'react';
import { Trophy, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Challenges() {
  const admin = localStorage.getItem('admin');
  if (!admin) {
    return (
      <div className="relative min-h-screen flex flex-col items-center justify-center bg-[#f6faff] dark:bg-[#181825] overflow-hidden">
        {/* Decorative Blobs */}
        <svg className="absolute -top-24 -left-24 w-[300px] h-[180px] opacity-60 animate-blob-float z-0" viewBox="0 0 300 180" fill="none"><ellipse cx="150" cy="90" rx="140" ry="80" fill="#b4befe" /></svg>
        <svg className="absolute top-1/4 right-0 w-[120px] h-[80px] opacity-40 animate-blob-float-slow z-0" viewBox="0 0 120 80" fill="none"><ellipse cx="60" cy="40" rx="60" ry="40" fill="#a6e3a1" /></svg>
        <svg className="absolute bottom-0 left-1/3 w-[80px] h-[60px] opacity-30 animate-blob-float z-0" viewBox="0 0 80 60" fill="none"><ellipse cx="40" cy="30" rx="40" ry="30" fill="#fab387" /></svg>
        <svg className="absolute bottom-10 right-10 w-12 h-12 z-0" viewBox="0 0 48 48" fill="none"><polygon points="24,4 29,18 44,18 32,28 36,44 24,35 12,44 16,28 4,18 19,18" fill="#f9e2af"/></svg>
        {/* Back to Home button (match Story) */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 mb-8 transition-colors text-lg
            text-[#232634] dark:text-[#f9e2af] font-bold
            px-3 py-1 rounded-lg bg-white/40 dark:bg-[#232634]/60 shadow-sm backdrop-blur-sm
            border border-[#e0d7d2] dark:border-[#45475a] sm:static top-4 left-2 z-20
            focus:outline-none focus:ring-2 focus:ring-[#b4befe] focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-[#181825]"
          style={{ maxWidth: 'fit-content' }}
        >
          <ArrowLeft size={20} />
          <span>Back to Home</span>
        </Link>
        <div className="flex flex-col items-center justify-center z-10">
          <span className="text-6xl mb-2">🧸</span>
          <h1 className="text-4xl md:text-5xl font-extrabold mb-2 text-center text-[#89b4fa] dark:text-[#b4befe]">Playground</h1>
          <p className="text-xl text-center text-[#a6adc8] dark:text-[#cdd6f4] mb-8">Coming Soon</p>
        </div>
      </div>
    );
  }

  const challenges = [
    {
      title: "100 Days of Code",
      description: "Join me in coding every day for 100 days",
      difficulty: "Beginner",
      participants: 156
    },
    {
      title: "Full Stack Project",
      description: "Build a complete web application from scratch",
      difficulty: "Intermediate",
      participants: 89
    },
    {
      title: "Algorithm Marathon",
      description: "Solve one algorithmic problem every day",
      difficulty: "Advanced",
      participants: 45
    }
  ];

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center bg-[#f6faff] dark:bg-[#181825] overflow-hidden">
      {/* Decorative Blobs */}
      <svg className="absolute -top-24 -left-24 w-[300px] h-[180px] opacity-60 animate-blob-float z-0" viewBox="0 0 300 180" fill="none"><ellipse cx="150" cy="90" rx="140" ry="80" fill="#b4befe" /></svg>
      <svg className="absolute top-1/4 right-0 w-[120px] h-[80px] opacity-40 animate-blob-float-slow z-0" viewBox="0 0 120 80" fill="none"><ellipse cx="60" cy="40" rx="60" ry="40" fill="#a6e3a1" /></svg>
      <svg className="absolute bottom-0 left-1/3 w-[80px] h-[60px] opacity-30 animate-blob-float z-0" viewBox="0 0 80 60" fill="none"><ellipse cx="40" cy="30" rx="40" ry="30" fill="#fab387" /></svg>
      <svg className="absolute bottom-10 right-10 w-12 h-12 z-0" viewBox="0 0 48 48" fill="none"><polygon points="24,4 29,18 44,18 32,28 36,44 24,35 12,44 16,28 4,18 19,18" fill="#f9e2af"/></svg>
      {/* Back to Home button (match Story) */}
      <Link
        to="/"
        className="inline-flex items-center gap-2 mb-8 transition-colors text-lg
          text-[#232634] dark:text-[#f9e2af] font-bold
          px-3 py-1 rounded-lg bg-white/40 dark:bg-[#232634]/60 shadow-sm backdrop-blur-sm
          border border-[#e0d7d2] dark:border-[#45475a] sm:static top-4 left-2 z-20
          focus:outline-none focus:ring-2 focus:ring-[#b4befe] focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-[#181825]"
        style={{ maxWidth: 'fit-content' }}
      >
        <ArrowLeft size={20} />
        <span>Back to Home</span>
      </Link>
      {/* Playground content */}
      <div className="flex flex-col items-center justify-center z-10">
        <span className="text-6xl mb-2">🧸</span>
        <h1 className="text-4xl md:text-5xl font-extrabold mb-2 text-center text-[#89b4fa] dark:text-[#b4befe]">Playground</h1>
        <p className="text-xl text-center text-[#a6adc8] dark:text-[#cdd6f4] mb-8">Coming Soon! Fun games and experiments are on the way.</p>
      </div>

      <div className="flex items-center gap-3 mb-8">
        <Trophy className="text-yellow-400" size={32} />
        <h2 className="text-3xl font-bold text-[#232634] dark:text-white">Challenges</h2>
      </div>
      
      <div className="grid gap-6">
        {challenges.map((challenge, index) => (
          <div key={index} className="bg-white dark:bg-gray-900 rounded-xl p-6 shadow hover:bg-gray-100 dark:hover:bg-gray-800/80 transition-all transform hover:scale-[1.02]">
            <div className="flex justify-between items-start mb-4">
              <h3 className="text-xl font-semibold text-[#232634] dark:text-white">{challenge.title}</h3>
              <span className="px-3 py-1 bg-gray-100 dark:bg-gray-800 text-[#232634] dark:text-white rounded-full text-sm">
                {challenge.difficulty}
              </span>
            </div>
            <p className="text-gray-500 dark:text-gray-400 mb-4">{challenge.description}</p>
            <div className="text-sm text-gray-400 dark:text-gray-500">
              {challenge.participants} participants
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}